import { isEmbeddedPage } from 'config/eva';

/**
 * The Osano CMP UI (and all non-essential tracking) is suppressed on
 * PWN Health white-label pages and embedded (Eva / native app) pages.
 */
export function isCmpUiSuppressed(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return Boolean(window.isPwnHealthPage) || isEmbeddedPage();
}
